import React, { Component } from 'react';
import { Formik } from 'formik';
import { Form, FormGroup, InputGroup, Input, Button } from 'reactstrap';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import PostMan from '../../utils/service';

//import { makeStyles } from '@material-ui/styles';
import './index.css';

// const useStyles = makeStyles(theme => ({
//   close: {
//     padding: theme.spacing(0.5),
//   },
// }));

const ValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Please enter your e-mail'),
});

const FormFeedback = ({ valid, children }) => valid ? null : (
  <div className="formfeedback">
    {children}
  </div>
)

class ForgotPassword extends Component {
  constructor() {
    super();
    this.state = {
      message: null,
      initialValues: {
        email: '',
      }
    }

    if (Cookies.get('token') || Cookies.get('accessToken')) {
      window.location = '/';
    }

  }

  onSubmit = (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
    PostMan.forgotPassword(values)
      .then(res => {
        values.email = ''
        this.setState({ message: "Please check email to reset your password" })
      })
      .catch((error) => {
        this.setState({ message: error.response.data.message })
        // resetForm({})
      })
  }

  mapPropsToValues = (props) => {
    return this.state.initialValues;
  }


  render() {
    const { openToast } = this.state
    // const classes = useStyles();
    const { auth, errors } = this.props
    return (
      <div className="login-wrapper">
        <div className="logo-wrapper">
          <img src="/static/img/logo_login.png" alt="logo" width="100%" />
        </div>
        <div className="login-form">
        <h3 className="text-center">Forgot Password</h3>
          <Formik
            initialValues={this.state.initialValues}
            validationSchema={ValidationSchema}
            onSubmit={this.onSubmit}
            enableReinitialize={true}
          >
            {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched }) => (
              <Form method="post" onSubmit={handleSubmit} noValidate name='subscribeForm' style={{ marginTop: 25 }}>
                <FormGroup>
                  <InputGroup>
                    <Input type="email"
                      name="email"
                      id="email"
                      placeholder="Email Address"
                      autoFocus={false}
                      onChange={handleChange}
                      required
                      value={values.email} />
                    <div className="input-group-append">
                      <span className="input-group-text"><i className="fa fa-envelope"></i></span>
                    </div>
                    <FormFeedback valid={(errors.email) ? false : true}>{errors.email}</FormFeedback>
                  </InputGroup>
                </FormGroup>
                <FormGroup style={{ marginLeft: 10 }}>
                  <Link to={`/login`} style={{ fontSize: 15, }}>Already have password?</Link>
                  <Button
                    type="submit" color="success" className="mr-1" style={{ float: "right" }}>Submit</Button>
                </FormGroup>
                <div style={{ color: "red" }}>{this.state.message}</div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;




// WEBPACK FOOTER //
// ./client/src/views/Auth/forgotPassword.js